import { SDK_NETWORK } from "./env"
import { ENABLE_ZERO_LOCK_TIME } from "./feature-flag"

export const LOCK_TIMES = [
  { period: 39, multiplier: 16 },
  { period: 24, multiplier: 10 },
  { period: 8, multiplier: 3 },
  ...(ENABLE_ZERO_LOCK_TIME ? [{ period: 0, multiplier: 0 }] : []),
] // specified in weeks

export const MATS_MULTIPLIER = 1_000
export const STABLECOINS_MATS_MULTIPLIER = 0.0125
export const STBTC_TOKENS_MATS_MULTIPLIER = 1_100
export const BITCOIN_NAME_UNLOCK = 0.05
export const BITCOIN_INVITE_CODES_UNLOCK = 0.01
export const MAX_DISPLAYED_MATS = 1_000_000
export const BITCOIN_DEPOSIT_FEE = 0.001
export const THRESHOLD_FEE = 0.002 // 0.2%
export const PORTAL_WITHDRAWAL_GAS_USAGE = 55_000 // average value from events
export const TBTC_BRIDGE_GAS_USAGE = 190_000 // average value from events
export const LEADERBOARD_FETCH_CHUNK = 20
export const SUPERSTACK_MATS_FACTOR = 1.1

export const DATABASE_DECIMALS_COUNT = 18

export const FRIENDLY_DECIMALS_AMOUNT = 6
export const DEPOSIT_BOX_FRIENDLY_DECIMALS_AMOUNT = 4

export const BASE_DAILY_MATS = {
  default: 1000,
  stablecoin: 500,
  stbtc: 1100,
}

export const VAULTS_DAILY_MATS_REWARD = 100_000

// Minimum BTC deposit amount that can be later withdrawn on sepolia
export const BITCOIN_SEPOLIA_MINIMUM_DEPOSIT_TO_WITHDRAW = 0.11
// Minimum BTC deposit amount that can be withdrawn (after fees)
export const BITCOIN_MINIMUM_WITHDRAWABLE_AMOUNT = 0.009

// Min BTC deposit - 0.011 (mainnet) and 0.00001 (sepolia)
export const BITCOIN_MIN_DEPOSIT = SDK_NETWORK === "mainnet" ? 0.01 : 0.0001
export const BITCOIN_MIN_DECIMALS = SDK_NETWORK === "mainnet" ? 2 : 4

// RFC1034 compatible
export const DISALLOWED_USERNAME_PATTERNS: {
  pattern: RegExp
  error: string
}[] = [
  // RFC1034: https://datatracker.ietf.org/doc/html/rfc1034.
  { pattern: /^$/, error: "Must not be empty." },
  { pattern: /^.{16,}$/, error: "Must have 15 characters or fewer." },
  {
    pattern: /^[^A-Za-z]/,
    error: "Must start with a one of the letters A-Z or a-z.",
  },
  {
    pattern: /[^A-Za-z0-9-]/,
    error:
      "Must only use letters or numbers (A-Z, a-z, or 0-9), or hyphen (-).",
  },
  { pattern: /-$/, error: "Must not end in a hyphen (-)." },
  // On-chain shenanigan avoidance.
  { pattern: /0x/i, error: "Must not contain 0x." },
  {
    pattern: /^(?:bc1|tb1|[a-z]pub|[a-z]priv)/i,
    error: "Must not start with a Bitcoin magic string.",
  },
  {
    pattern: /^m[0-9]+$/i,
    error: 'No "m" + "numeric string" prefixes.',
  },
]
